/**
 * @Description 商圈编辑表单
 */

import { FC, useEffect } from 'react';
import { Form, Modal } from 'antd';
import { useMethods } from '@lhb/hook';
import { isArray } from '@lhb/func';
import { updateAreaDetailInfo } from '@/common/api/siteselectionmap';
// import cs from 'classnames';
// import styles from './entry.module.less';
import V2Form from '@/common/components/Form/V2Form';
import V2FormUpload from '@/common/components/Form/V2FormUpload/V2FormUpload';
import V2FormTextArea from '@/common/components/Form/V2FormTextArea/V2FormTextArea';

interface EditFormModalProps {
  [p:string]: any;
}
const EditFormModal: FC<EditFormModalProps> = ({
  id,
  areaAlias,
  modalData,
  setModalData,
}) => {
  const [form] = Form.useForm();
  const { open, data } = modalData;

  useEffect(() => {
    // 更新form
    if (open) {
      const { remark, attachment } = data;
      remark && form.setFieldValue('remark', remark);
      isArray(attachment) && attachment.length && form.setFieldValue('attachment', attachment);
    }
  }, [data, open]);
  const methods = useMethods({
    handleSubmit: () => {
      form.validateFields().then((res: any) => {
        const { remark, attachment } = res || {};
        const params: any = {
          modelClusterId: id,
          remark,
          attachment
        };
        updateAreaDetailInfo(params).then(() => {
          // 注意这里不清空表单
          setModalData({
            open: false,
            data: {
              remark,
              attachment
            }
          });
        });
      });
    }
  });
  return (
    <Modal
      title={`编辑${areaAlias}信息`}
      open={open}
      onCancel={() => setModalData((state) => ({ ...state, open: false }))}
      maskClosable={false}
      width={360}
      onOk={methods.handleSubmit}
    >
      <V2Form form={form}>
        <V2FormTextArea
          label='备注'
          name='remark'
          placeholder='请输入备注，最多500字'
          maxLength={500}
          config={{ showCount: true }}
        />
        <V2FormUpload
          label='上传附件'
          name='attachment'
          promptFileAllSuccess
          config={{
            maxCount: 9,
            size: 500,
          }}
        />
      </V2Form>
    </Modal>
  );
};

export default EditFormModal;
